import { io } from 'socket.io-client';

const url = import.meta.env.VITE_REALTIME_SERVICE_URL as string;
const appName = import.meta.env.VITE_APP_NAME as string;

const socket = io(`${url}careezy`, {
  transports: ['websocket'],
  autoConnect: false,
  auth: {
    token: localStorage.getItem('accessToken') || ''
  }
});

socket.on('connect', () => {
  console.log('✅ Socket connected:', socket.id);

  const tenantSlug = localStorage.getItem('tenantSlug') || '';

  socket.emit('joinRoom', { tenantSlug, appName });
});

socket.on('disconnect', reason => {
  console.warn('⚠️ Socket disconnected:', reason);
});

socket.on('connect_error', error => {
  console.error('❌ Connection error:', error.message);
});

socket.io.on('reconnect_attempt', attempt => {
  console.log('🔁 Reconnecting... Attempt:', attempt);
});

socket.io.on('reconnect', attempt => {
  console.log('✅ Reconnected after', attempt, 'attempt(s)');
});

export const connectSocket = (token: string) => {
  socket.auth = { token };

  if (!socket.connected) {
    socket.connect();
  }
};

// Updates the credentials used on the next (re)connect without touching the current connection
export const updateSocketToken = (token: string) => {
  socket.auth = { token };
};

export const disconnectSocket = () => {
  socket.disconnect();
};

export default socket;
